import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const FursysStyle = styled('div')`
  ${media.mobile} {
    overflow-x: hidden;
  }
  .fursys-main {
    position: relative;
    padding-bottom: 120px;
    background-color: #403b36;
    ${media.mobile} {
      padding-bottom: 64px;
    }
    &::before {
      content: '';
      position: absolute;
      left: 48%;
      top: -37px;
      transform: rotate(45deg);
      height: 74px;
      width: 74px;
      background-color: #d7d7d6;
      ${media.mobile} {
        left: 45%;
        top: -18px;
        height: 37px;
        width: 37px;
      }
    }
  }
`;

export default FursysStyle;
